module.exports = __webpack_public_path__ + "img/official-8.235dc003.png";